import { useCallback, useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getHomeSummary } from "@/api/homeSummary";
import type { QueueScope } from "@/api/types";

const ONE_MINUTE = 60_000;

export const HOME_QUEUE_KEY = "homeQueue";

/**
 * F6 Home Unified Action Queue data layer.
 * - scope state (my | team); refetch on scope change via query key
 * - loading / error / refetch surfaced from react-query
 * - invalidate() refreshes after a drawer action completes (sub_4 cache invalidation)
 */
export function useHomeQueue() {
  const [scope, setScope] = useState<QueueScope>("my");
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: [HOME_QUEUE_KEY, scope],
    queryFn: ({ signal }) => getHomeSummary(scope, signal),
    staleTime: ONE_MINUTE,
  });

  const invalidate = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: [HOME_QUEUE_KEY] });
  }, [queryClient]);

  return { ...query, scope, setScope, invalidate };
}
